"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = ForgotPasswordPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var auth_layout_1 = require("../../components/auth/auth-layout");
var forgot_password_form_1 = require("../../components/auth/forgot-password-form");
var routes_1 = require("../../constants/routes");
var hooks_1 = require("../../store/hooks");
function ForgotPasswordPage() {
    var accessToken = (0, hooks_1.useAppSelector)(function (state) { return state.user.token; });
    if (accessToken) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.TASKS_DASHBOARD, replace: true });
    }
    return ((0, jsx_runtime_1.jsx)(auth_layout_1.AuthLayout, { title: "Reset Password.", subtitle: "We'll email you a link to reset your password.", children: (0, jsx_runtime_1.jsx)(forgot_password_form_1.ForgotPasswordForm, {}) }));
}
